<template>
  <div>
    <InputField
      ref="input"
      v-model="value"
      type="number"
      :field="field"
      :field-wrapper="true"
    />
  </div>
</template>

<script>
import InputField from "@/components/Tools/FormHelper/Components/Input";
import {
  base,
  eagerValidation
} from "@/components/Tools/FormHelper/Helper/mixins";

export default {
  components: { InputField },
  mixins: [base, eagerValidation],
  computed: {
    value: {
      get: function () {
        // Return inherited value
        return this.defaultValue;
      },
      set: function (value) {
        // We have to convert the value to a number if the value exists and the last char is not a dot
        if (
          value &&
          value.charAt(value.length - 1) !== "." &&
          !this.enableVariables
        ) {
          value = parseFloat(value);
        }
        // Trigger change event firstly, to add old value to payload
        this.onChange(value);
        // Trigger input event with new value
        this.onInput(value);
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.input.validate();
    }
  }
};
</script>
